import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { BaseComponent, BottoneAPI, Trad, CampoPassword } from '../components/';

interface IRecuperaPasswordState {
    Codice: string;
    Password: string;
    Password2: string;
}

export class RecuperaPassword extends BaseComponent<Glob.IRouteGlobaleProps, IRecuperaPasswordState> {
    public constructor(props: any) {
        super(props);
        this.state = { Codice: (this.props.match.params as any).Codice, Password: "", Password2: "" };

        this.OnInvio = this.OnInvio.bind(this);
    }

    private OnClick(sender: BottoneAPI, dati: Dati.CRisAPIDatoSessioni) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("Aggiorna password"), Trad.Trad("PasswordAggiornata"), () => { this.props.history.push('/login') });
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
    }

    private OnInvio(sender: BottoneAPI): any {
        if (this.state.Password != this.state.Password2) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("Passwords mismatch"));
            return false;
        }

        var Ingr = new Dati.CIngrAPI<Dati.CDatiRecuperaPassword>();
        Ingr.Dato = new Dati.CDatiRecuperaPassword();
        Ingr.Dato.Codice = this.state.Codice;
        Ingr.Dato.Password = this.state.Password;
        return Ingr;
    }

    public render() {
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon lt--hide"><i className="la la-gear"></i></span>
                        <h3 className="kt-portlet__head-label">{Trad.Trad("Aggiorna password")}</h3>
                    </div>
                </div>
            </div>
            <form className="kt-form login-form kt-form login-form--fit">
                <div className="kt-portlet__body">
                    <div className="kt-form login-form__section kt-form login-form__section--first">
                        <div className="form-group kt-form login-form__group hidden">
                            <div className="kt-input-icon kt-input-icon--left">
                                <input className="form-control kt-input" placeholder="Code" id="Code" type="text" required value={this.state.Codice} onChange={(e) => { this.OnChange(e) }} />
                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="fa fa-key"></i></span></span>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group">
                            <div className="kt-input-icon kt-input-icon--left">
                                <CampoPassword Name="Password" Id="Password" Valore={this.state.Password} OnChange={(e) => { this.OnChange(e) }} Required={true} AutoComplete="current-password" DimensioneCSS={6} />
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group">
                            <div className="kt-input-icon kt-input-icon--left">
                                <CampoPassword Name="Password2" Id="Password2" Valore={this.state.Password2} OnChange={(e) => { this.OnChange(e) }} Required={true} AutoComplete="current-password" DimensioneCSS={6} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--solid">
                        <div className="divtabella">
                            <BottoneAPI OnInvio={this.OnInvio} Testo={Trad.Trad("Aggiorna password")} URL="/api/Utenti/RecuperaPassword" OnClick={(s, d) => this.OnClick(s, d)} Metodo="POST" OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/form/RecuperaPassword.tsx